import { LinearProgress, LinearProgressProps } from '@mui/material';
import clsx from 'clsx';

import { Sizes } from '../../../types';

export type ProgressBarProps = LinearProgressProps & {
  size: Sizes<'sm' | 'md' | 'lg' | 'xl'>;
  disabled?: boolean;
};

export const ProgressBar = (props: ProgressBarProps) => {
  return (
    <LinearProgress
      {...props}
      className={clsx(
        props.className,
        `DSuiProgressBar-size-${props.size}`,
        props.disabled && 'DSuiProgressBar-disabled'
      )}
    />
  );
};
